import React from 'react'
import { useEvent } from '@/modules/event/eventSlice'
import Gtm from './Gtm'

const EventGtm = () => {

  const event = useEvent()
  const [gtmKey, setGtmKey] = React.useState('')

  React.useEffect(() => {
    if (event) {
      if (event.orgGoogleTagManagerKey) {
        setGtmKey(event.orgGoogleTagManagerKey)
      }
    }
  }, [event])

  return (
    <>
      {
        gtmKey
        ? <Gtm gtmKey={gtmKey} />
        : <></>
      }
    </>
  )
}

export default EventGtm
